import { take, put } from "redux-saga/effects";
import { GET_ASSIGNMENT_DETAILS, getAssignmentDetailsActions } from "src/redux/actions/assignments";

// services
import { getAssignmentDetails } from "src/services/http/assignments";

// types
import { GetAssignmentDetailsResponseTypes } from "src/redux/actions/assignments/types";

import * as Effects from "redux-saga/effects";

const call: any = Effects.call;

function* watchAssignmentDetailsRequest() {
  while (true) {
    const { payload } = yield take(GET_ASSIGNMENT_DETAILS.REQUEST);

    try {
      const result: GetAssignmentDetailsResponseTypes = yield call(getAssignmentDetails, {
        quizId: payload.quizId,
        userId: payload.userId
      });
      yield put(getAssignmentDetailsActions.success(result));
    } catch (e) {
      console.log(e, "error");
      yield put(getAssignmentDetailsActions.error(e as any));
    }
  }
}

export default watchAssignmentDetailsRequest;
